import './CFINoteGrid.scss'
import DataGrid, { Column, Item, LoadPanel, Paging, Scrolling, SearchPanel, Toolbar } from 'devextreme-react/data-grid';
import { encode } from 'html-entities';
import { KindOfOrder } from '../../../../types/enums';
import { useGetCFINotes } from '../api/get-cfi-notes';
import { Link } from 'react-router-dom';
import { showErrorMessage } from '../../../../utils/messages';
import Button from 'devextreme-react/button';
import { useState } from 'react';
import { LoadPagePanel } from '../../../../components';
import { AddNoteParams } from '../../../common/notes/types/AddNoteParams';
import AddNotePopup from '../../../common/notes/components/AddNotePopup';
import { useMarkCFINoteAsRead } from '../api/mark-cfi-note-as-read';

export default function CFINoteGrid() {

	const cfiNotes = useGetCFINotes();

	const markNoteAsRead = useMarkCFINoteAsRead(
		() => cfiNotes.refetch(),
		(error) => showErrorMessage(error));

	const [isPopupVisible, setPopupVisibility] = useState(false);
	const [noteParams, setNoteParams] = useState<AddNoteParams>();

	return (
		<>
			{
				cfiNotes.data?.length > 0 ?
					<DataGrid
						className={'dx-card wide-card cfi-notes-grid'}
						dataSource={cfiNotes.data}
						allowColumnReordering={true}
						allowColumnResizing={true}
						showBorders={true}
						showColumnLines={true}
						columnAutoWidth={true}
						keyExpr={'noteID'}
						height="68vh"
					>
						<LoadPanel enabled={false} />
						<Paging enabled={false}></Paging>
						<Scrolling rowRenderingMode='virtual'></Scrolling>
						<SearchPanel visible={true} />

						<Toolbar visible={cfiNotes.data?.length > 0}>
							<Item location='before' name='searchPanel'>
							</Item>
							<Item location='after'>
								<Button
									text="Mark All As Read"
									icon="Inscyth-Order-Material"
									onClick={() => markNoteAsRead.mutate({})}>
								</Button>
							</Item>
						</Toolbar>

						<Column
							dataField={'orderNumber'}
							caption={'Order #'}
							dataType="string"
							cellRender={(row: any) => {
								if (row.data.kindOfOrderID === KindOfOrder.RetailOrder) {
									return <Link to={`/dealer/retail-order/${row.data.orderID}`}>
										{row.data.orderNumber}
									</Link>;
								}
								else if (row.data.kindOfOrderID === KindOfOrder.WorkOrder) {
									return <Link to={`/dealer/work-order/${row.data.orderID}`}>
										{row.data.orderNumber}
									</Link>;
								}
								else if (row.data.kindOfOrderID === KindOfOrder.Estimate) {
									return <Link to={`/dealer/estimate/${row.data.orderID}`}>
										{row.data.orderNumber}
									</Link>;
								}

								return <>{row.data.orderNumber}</>;
							}}
						/>
						<Column
							dataField={'customerName'}
							caption={'Customer Name'}
							dataType="string"
						/>
						<Column
							dataField={'createdBy'}
							caption={'Creator'}
							dataType="string"
						/>
						<Column
							dataField={'createdOn'}
							caption={'Created On'}
							dataType="datetime"
						/>
						<Column
							dataField={'cfiName'}
							caption={'CFI'}
							dataType="string"
						/>
						<Column
							dataField={'noteText'}
							caption={'Message'}
							dataType="string"
							cssClass={'multi-line'}
							encodeHtml={false}
							calculateDisplayValue={(rowData) => {
								return encode(rowData.noteText).replaceAll('\r\n', '<br/>');
							}}
						/>
						<Column
							width={200}
							cellRender={(row: any) => {
								return <>
									<a onClick={(e) => {
										e.preventDefault();
										markNoteAsRead.mutate({ noteID: row.data.noteID });
									}}>
										Mark as read
									</a>
									<Button
										text="Reply"
										className='reply-button' onClick={() => {
											setNoteParams({
												showNoteType: false,
												emailSubject: `${row.data.orderNumber} - ${row.data.customerName.trim()} - Project # ${row.data.projectNumber}`,
												companyIDs: [row.data.assignedCompanyID, row.data.dealerCompanyID],
												kindOfOrder: row.data.kindOfOrderID,
												orderID: row.data.orderID,
												onNoteAdded: () => { markNoteAsRead.mutate({ noteID: row.data.noteID }); }
											});
											setPopupVisibility(true);
										}}>
									</Button>
								</>;
							}}
						/>
					</DataGrid>
					:
					<div>
						{!cfiNotes.isLoading && 'There are no more messages to read at the moment.'}
					</div>
			}
			{
				isPopupVisible &&
				<AddNotePopup
					caption="Reply to Note"
					params={noteParams!}
					onHidePopup={() => setPopupVisibility(false)} />
			}

			<LoadPagePanel visible={cfiNotes.isLoading || cfiNotes.isRefetching || markNoteAsRead.isLoading} />
		</>
	)
}
